import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import CookieConsent from "@/components/CookieConsent";
import CursorGlow from "@/components/CursorGlow";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import PageTransition from "@/components/PageTransition";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index";
import Leistungen from "./pages/Leistungen";
import Projekte from "./pages/Projekte";
import UeberUns from "./pages/UeberUns";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import NotFound from "./pages/NotFound";
import Unsubscribe from "./pages/Unsubscribe";
import Kalender from "./pages/Kalender";
import MotorsportVideoproduktion from "./pages/MotorsportVideoproduktion";
import SportContent from "./pages/SportContent";
import Eventfilm from "./pages/Eventfilm";
import VideoproduktionBochum from "./pages/VideoproduktionBochum";
import VideoproduktionRuhrgebiet from "./pages/VideoproduktionRuhrgebiet";
import VideoproduktionNRW from "./pages/VideoproduktionNRW";
import ImagefilmBochum from "./pages/ImagefilmBochum";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <PageTransition key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<Index />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/projekte" element={<Projekte />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/kalender" element={<Kalender />} />
          <Route path="/motorsport-videoproduktion" element={<MotorsportVideoproduktion />} />
          <Route path="/sport-content" element={<SportContent />} />
          <Route path="/eventfilm" element={<Eventfilm />} />
          <Route path="/videoproduktion-bochum" element={<VideoproduktionBochum />} />
          <Route path="/videoproduktion-ruhrgebiet" element={<VideoproduktionRuhrgebiet />} />
          <Route path="/videoproduktion-nrw" element={<VideoproduktionNRW />} />
          <Route path="/imagefilm-bochum" element={<ImagefilmBochum />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PageTransition>
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <CursorGlow />
      <BrowserRouter>
        <AnimatedRoutes />
        <WhatsAppFloat />
        <CookieConsent />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
